import React from 'react'

export default ({
    value = '', 
    handleChange
}) => {
    return (
        <textarea 
            value={value}
            onChange={e => handleChange(e.target.value)}
        />
    )
}